import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppModalsProvider } from './context/AppModalsContext';
import { ShareTargetHandler } from './components/ShareTargetHandler';
import { CheckoutHandler } from './components/CheckoutHandler';
import { AddLinkModalGlobal } from './components/AddLinkModalGlobal';
import { AuthModal } from './components/product/AuthModal';
import { AuthGuard } from './components/AuthGuard';
import { useAppModals } from './hooks/useAppModals';
import { LinksScreen, GroupsScreen, GroupDetailScreen, FilesScreen, FAQScreen, AboutScreen, PrivacyPolicyScreen, SettingsScreen } from './screens';
import { useAuthStore } from './stores/authStore';
import { useSubscriptionStore } from './stores/subscriptionStore';
import { useTheme } from './hooks/useTheme';
import { supabase, isSupabaseConfigured } from './lib/supabase';

const AppContent = () => {
  const { isAuthPromptOpen, closeAuthPrompt } = useAppModals();

  return (
    <>
      <ShareTargetHandler />
      <CheckoutHandler />
      <AddLinkModalGlobal />
      <AuthModal isOpen={isAuthPromptOpen} onClose={closeAuthPrompt} />
      <Routes>
        <Route path="/" element={<AuthGuard />}>
          <Route index element={<LinksScreen />} />
          <Route path="groups" element={<GroupsScreen />} />
          <Route path="groups/:id" element={<GroupDetailScreen />} />
          <Route path="files" element={<FilesScreen />} />
          <Route path="faq" element={<FAQScreen />} />
          <Route path="about" element={<AboutScreen />} />
          <Route path="privacy" element={<PrivacyPolicyScreen />} />
          <Route path="settings" element={<SettingsScreen />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export const App = () => {
  const { user, isAuthenticated, initialize } = useAuthStore();
  const { initialize: initSubscription } = useSubscriptionStore();

  useTheme();

  useEffect(() => {
    if (isSupabaseConfigured() && supabase) {
      initialize().catch(console.error);
    }
  }, [initialize]);

  useEffect(() => {
    if (isAuthenticated && user?.id) {
      initSubscription();
    } else if (!isAuthenticated) {
      useSubscriptionStore.setState({ isLoading: false, isActive: false, plan: 'free' });
    }
  }, [isAuthenticated, user?.id, initSubscription]);

  return (
    <AppModalsProvider>
      <AppContent />
    </AppModalsProvider>
  );
};
